import { uniq } from "lodash";
import { createSelector } from "reselect";

import { getTripsSegments } from "@app/modules/checkout/store/v2/selectors/state-accessors";

export const getSourceNamesForAllSegments = createSelector(
  getTripsSegments,
  trips_segments => {
    return uniq(
      Object.values(trips_segments)
        .map(segment => segment.source_name)
        .filter(Boolean)
    );
  }
);
